import { render, staticRenderFns } from "./formbuilderTemplatePreview.vue?vue&type=template&id=138ee215&scoped=true"
import script from "./formbuilderTemplatePreview.vue?vue&type=script&lang=js"
export * from "./formbuilderTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./formbuilderTemplatePreview.vue?vue&type=style&index=0&id=138ee215&prod&lang=scss&scoped=true"
import style1 from "./formbuilderTemplatePreview.vue?vue&type=style&index=1&id=138ee215&prod&lang=scss&scoped=true"
import style2 from "./formbuilderTemplatePreview.vue?vue&type=style&index=2&id=138ee215&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ee215",
  null
  
)

export default component.exports